import { r as registerInstance, h } from './index-5faac9d7.js';
import { b as productCtas, W as RANGE, a4 as CAASContentOverviewSlotName } from './currency-49e0d692.js';
import { r as requestRangeSelectorConfig } from './helper-baea569d.js';
import { u as updateProductCtasSelectorSettings } from './product-selector-utils-df1f9eca.js';
import { T as TAB_NAMES } from './constants-74678075.js';
import { a as getFilteredBreadcrumbs } from './utils-1b416b6b.js';
import './product-card-78a466f2.js';
import { s as store } from './pes-router-store-498d2799.js';
import './store-a2f488b2.js';
import './index-39f51a91.js';
import './analytics-74fe4f64.js';
import './analytics-b3108572.js';
import './number-fcf5283d.js';
import './navigation-83d2f79a.js';
import './constants-7d3b1dc0.js';
import './pick-8e119733.js';
import './_basePickBy-19dc1369.js';
import './_arrayLikeKeys-26c55d84.js';
import './isEmpty-ea893565.js';
import './_nodeUtil-549406aa.js';
import './_commonjsHelpers-7db8bc26.js';
import './isSymbol-8fefec05.js';
import './_Stack-cf94d4e7.js';
import './toString-568546f3.js';
import './_isIndex-3036d479.js';
import './keysIn-b6895676.js';
import './hasIn-833a7ad2.js';
import './_flatRest-cc9038d0.js';
import './_baseFlatten-eecfdcde.js';
import './index-43880fda.js';
import './pes-product-link-74e48119.js';
import './utils-cdf9de4e.js';
import './helpers-cd261aee.js';
import './tslib.es6-613ce1cd.js';
import './toNumber-d92ee08f.js';
import './index-67820103.js';
import './utils-2fbd0743.js';
import './_baseFor-a28737de.js';
import './_copyObject-3791899f.js';
import './utils-6c8f178b.js';
import './index-54dd34b7.js';
import './lodash-7f024380.js';

const PBS_BACKGROUND_COLOR = '#FFF';

const ProductAppRange = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productCtasState = this.productCtas;
    this.productSelector = null;
    this.SE_BRAND = 'se';
    this.requestRangeSelectorConfigCreator = () => requestRangeSelectorConfig(this.host, this.rangeId, {
      countryCode: this.countryCode,
      languageCode: this.languageCode,
      brand: this.SE_BRAND,
    });
    this.host = undefined;
    this.endpoint = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.rangeId = undefined;
    this.showBreadcrumbs = undefined;
    this.showDocuments = undefined;
    this.productCtas = productCtas;
    this.showBuyOnline = undefined;
    this.siteType = undefined;
    this.mainInfo = undefined;
    this.tabs = undefined;
    this.recentlyViewedProducts = undefined;
    this.metaTags = undefined;
    this.isTabsInitialized = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.documentListing = undefined;
    this.hostWithLocale = '';
  }
  productCtasDidChange(newProductCtas) {
    this.selectorExtraOptions = updateProductCtasSelectorSettings(this.productSelector, this.productCtas.buttons);
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs((_a = this.mainInfo) === null || _a === void 0 ? void 0 : _a.breadcrumbs);
  }
  getRichText(content) {
    const { richText } = content;
    const richTextResponse = richText || content.MainContent[0].richText;
    return richTextResponse === null || richTextResponse === void 0 ? void 0 : richTextResponse.map((item) => item.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim());
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
  }
  componentWillLoad() {
    this.hostWithLocale = `${this.host}${this.countryCode}/${this.languageCode}/`;
  }
  render() {
    const { image, name, description, masterRangeName, longDescription, rangePartofLabel, } = this.mainInfo;
    const { analyticsPageData } = this.metaTags;
    return (h("se-container", { display: "block", style: {
        'background-color': PBS_BACKGROUND_COLOR,
      } }, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: false, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs", hostWithLocale: this.hostWithLocale })), h("pes-range-main", { host: this.host, endpoint: this.endpoint, rangePartofLabel: rangePartofLabel, commercialStatus: this.mainInfo.commercialStatus, description: description, image: image, longDescription: longDescription, masterRangeName: masterRangeName, name: name, brandLogo: this.mainInfo.brandLogo, id: this.mainInfo.id, localeCode: `${this.countryCode.toUpperCase()}/${this.languageCode}`, rangeCtas: this.mainInfo.rangeCtas, requestRangeSelectorConfig: this.requestRangeSelectorConfigCreator, readMoreLabel: this.mainInfo.readMoreLabel, readLessLabel: this.mainInfo.readLessLabel, learnMoreLabel: this.mainInfo.learnMoreLabel, moreOptionsLabel: this.mainInfo.moreOptionsLabel, rangeType: this.mainInfo.rangeType }), this.tabs.tabs && (h("pes-spryker-range-tabs", { tabs: this.tabs.tabs, hostWithLocale: this.hostWithLocale, appProductsLabel: this.mainInfo.appProductsLabel, commonFiltersFilterBy: this.mainInfo.commonFiltersFilterBy, facetButtonResetAllLabel: this.mainInfo.facetButtonResetAllLabel, facetButtonViewLessFilters: this.mainInfo.facetButtonViewLessFilters, facetButtonViewMoreFilters: this.mainInfo.facetButtonViewMoreFilters, nextLabel: this.mainInfo.nextLabel, pageLabel: this.tabs.pageLabel, noResultsClearLink: this.mainInfo.noResultsClearLink, noResultsHeader: this.mainInfo.noResultsHeader, noResultsMessage: this.mainInfo.noResultsMessage, numberProductsOfAllProductsLabel: this.mainInfo.numberProductsOfAllProductsLabel, previousLabel: this.mainInfo.previousLabel, rangeProductLabel: this.mainInfo.rangeProductLabel, rangeProductsFiltersLabel: this.mainInfo.rangeProductsFiltersLabel, viewLessLabel: this.mainInfo.viewLessLabel, viewMoreLabel: this.mainInfo.viewMoreLabel, viewProductsLabel: this.mainInfo.viewProductsLabel, rangePresentationLabel: this.mainInfo.rangePresentationLabel, loadMoreLabel: this.tabs.loadMoreLabel, loadPreviousLabel: this.tabs.loadPreviousLabel, backLabel: this.mainInfo.backLabel, localeCode: `/${this.countryCode}/${this.languageCode}`, rangeReference: this.mainInfo.rangeReference, host: this.host, endpoint: this.endpoint, rangeSoftwareAndFirmwareLabel: this.tabs.rangeSoftwareAndFirmwareLabel, rangeWebinarsAndResourcesLabel: this.tabs.rangeWebinarsAndResourcesLabel, softwareRegistrationLabel: this.tabs.softwareRegistrationLabel, descriptionBigger: this.mainInfo.descriptionBigger, id: this.mainInfo.id, name: name, navigationState: this.mainInfo.navigationState, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, productCtas: this.productCtasState, isPBS: true, documentListing: this.documentListing, analyticsPageData: analyticsPageData }, h("slot", { slot: CAASContentOverviewSlotName, name: CAASContentOverviewSlotName }))), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { isBackgroundGrey: true, class: "pes-app-range__section", hostWithLocale: this.host, pageId: this.rangeId, pageType: RANGE }))));
  }
  static get watchers() { return {
    "productCtas": ["productCtasDidChange"]
  }; }
};

export { ProductAppRange as pes_app_spryker_range };
